<template lang="html">
  <el-select v-model="carShowId" :multiple="multiple" :placeholder="placeholder"
             clearable
             filterable
             remote
             reserve-keyword
             :remote-method="remoteMethod"
             @change="$emit('change',carShowId)">
    <el-option
            v-for="item in carShows"
            :key="item.id"
            :label="item.name"
            :value="item.id">
   </el-option>

  </el-select>
</template>

<script>
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'car-show-select',
  data: function () {
    return {
      carShows: [],
      carShowId: []
    }
  },
  props: {
    multiple: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    placeholder: {
      type: String,
      default: function () {
        return '请选择'
      }
    }
  },
  created () {
    this.findCarShows('')
  },
  mounted () {
    console.log('==============>mounted')
  },
  methods: {
    remoteMethod (query) {
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.findCarShows(query)
        }, 200)
      } else {
        this.options = []
      }
    },
    settingDefaultSelectInfo (info) {
      this.carShows = [info]
      this.carShowId = info.id
    },
    clear: function () {
      this.carShowId = []
    },
    findCarShows: function (query) {
      let params = {
        keyword: query,
        pageNum: 1,
        pageSize: 20
      }

      let userInfo = JSON.parse(localStorage.userInfo)
      if (userInfo.loginPath === 'channel') {
        params.channelId = userInfo.id
      }

      let _this = this
      let listener = {
        success: function (dataInfo) {
          _this.carShows = dataInfo.data
        }
      }
      BasicModel.get(_this, 'carShow/carShowInfo/findCarShows.action', params, listener)
    }
  }
}
</script>
